import React from 'react';

export default function Education(){
    return(
        <div className='education-container' >
            <h2 className='edu-details-title'>Education Details</h2>
            <div className='edu-details-container' >
                <p className='edu-item'>Velammal Engneering Collage</p>
                <p className='edu-year' style={{textAlign:"right"}}>*2024</p>
            </div>
            <div className='edu-details-container' >
                <p className='edu-item'>Vijayantha Model Higher Secondary School</p>
                <p className='edu-year' style={{textAlign:"right"}}>2020</p>
            </div>
            <div className='edu-details-container' >
                <p className='edu-item'>Kendriya Vidhayala C.R.P.F</p>
                <p className='edu-year' style={{textAlign:"right"}}>2018</p>
            </div>
        </div>
    )
}